import React, { useState } from 'react'
import { getBEMCls } from '@/utils/classname'
import { Expaned } from '@/components/layout/layout'
import Button from '@/components/button/button'
import PurchaseTable from './modules/purchase-table/purchase-table'
import { DatePicker } from 'antd'

import './purchase-order.scss'
import EditPurchase from './modules/edit-purchase/edit-purchase'
import { showLayer } from '@/utils/layer'

const PurchaseOrder = () => {
    const getCls = (e?: string, m?: string) => getBEMCls('purchase-order', e, m)
    const [dateString, setDateString] = useState<string[]>([])

    return (
        <>
            <Expaned className={getCls()}>
                <div className={getCls('header')}>
                    <Button
                        types="default"
                        onClick={() => {
                            showLayer(<EditPurchase />)
                        }}
                    >
                        新建采购单
                    </Button>
                    <div
                        className="time-picker"
                        style={{
                            marginLeft: '16px',
                        }}
                    >
                        <DatePicker.RangePicker
                            dateRender={current => (
                                <div
                                    className="ant-picker-cell-inner"
                                    style={{
                                        borderRadius: '50%',
                                    }}
                                >
                                    {current.date()}
                                </div>
                            )}
                            onChange={(monent, dateString) => {
                                setDateString(dateString)
                            }}
                            suffixIcon={<i className="iconfont iconshijianshaixuan" />}
                        />
                    </div>
                </div>
                <Expaned data-row className={getCls('content')}>
                    <PurchaseTable dateString={dateString} />
                </Expaned>
            </Expaned>
        </>
    )
}

export default PurchaseOrder
